import React from 'react';
import { Toaster } from 'sonner';

export const MyNotificationsProvider = () => {
    return <Toaster position={'top-right'} richColors={true} />;
};
